var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('b',[_vm._v("Hinweis an den Autor der Aufgabe:")]),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }